import { z } from 'zod';
import i18n from 'i18next';

function t(key: string): string {
  return i18n.t(key);
}

export const loginSchema = z.object({
  username: z.string().email(t('validations.emailInvalid')),
  password: z.string().min(8, t('validations.passwordMin')),
});

export const emailSchema = z.object({
  email: z.string().email(t('validations.emailInvalid')),
});

export const passwordSchema = z
  .object({
    password: z
      .string()
      .min(8, t('validations.passwordMin'))
      .max(14, t('validations.passwordMax'))
      .regex(/[A-Z]/, t('general.passwordMissingUppercase'))
      .regex(/[0-9]/, t('general.passwordMissingDigit'))
      .regex(/[!@#$%^&*]/, t('general.passwordMissingSpecial')),
    confirmPassword: z.string(),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: t('general.passwordsDontMatch'),
    path: ['confirmPassword'],
  });

export type LoginFormData = z.infer<typeof loginSchema>;
export type EmailFormData = z.infer<typeof emailSchema>;
export type PasswordFormData = z.infer<typeof passwordSchema>;
